import Info from 'components/info/info';

export default Info;
